import React from 'react';
import cx from 'classnames';

const RadioButton = ({
  isActive,
  isDisabled,
  onClick,
}) => {
  const buttonClasses = cx({
    'RadioButton': true,
    'is-buttonActive': isActive,
  });

  return (
    <button
      aria-disabled={ isDisabled }
      className={ buttonClasses }
      disabled={ isDisabled }
      onClick={ onClick }
      type='button'>
      <div className='RadioButton-buttonContent'>
        <span className='RadioButton-radio' />
      </div>
    </button>
  );
};

export default RadioButton;
